import Constants from "../Math/Constants";
import Monster, { MonsterConfig } from "../Monster";
import { BasicMobGenerate, IOneTimeMobGenerator } from "./IMobGenerate";

export default class OneTimeMobGenerator extends BasicMobGenerate {
    private mHasGenerated: boolean = false;

    constructor(mobConfigs: MonsterConfig[], scene?: Phaser.Scene) {
        super(scene);
        this.Mobs = mobConfigs;
    }

    ShouldGenerate(elapsedSeconds: number): boolean {
        if (this.mHasGenerated) {
            return false;
        }

        let isStillInDuration = elapsedSeconds / 60 <= this.DurationActiveMinutes;
        let hasPassedDelay = elapsedSeconds >= this.DelaySecondUntilBegin;

        console.log(`Is Active? ${this.IsActive}, is in duration? ${isStillInDuration}, hasPassDelay? ${hasPassedDelay}`);
        let result = isStillInDuration && hasPassedDelay && this.IsActive;
        this.mHasGenerated = result;
        return result;
    }

    Generate(): Monster[] {
        if (this.mAttachedScene == null) {
            throw "Attached scene is null!";
        }

        let monsters: Monster[] = [];

        this.Mobs.forEach(mobConfig => {

            let sprite = this.mAttachedScene?.physics.add.staticSprite(0, 0, mobConfig.Name);
            sprite?.play(`anim_${mobConfig.Name}`);
            let gameSize = this.mAttachedScene?.sys.game.scale.gameSize;

            if (sprite == undefined || gameSize == undefined) { return; }
            
            sprite.setScale(mobConfig.Scale ?? 1);
            sprite.refreshBody();

            let monster = new Monster(sprite, this.mAttachedScene, mobConfig);

            let yAxisAdjust = sprite?.height / 2
            monster.SetPosition(new Phaser.Math.Vector2(gameSize?.width, gameSize?.height - yAxisAdjust));

            this.Positioner.Position(monster);

            monsters.push(monster);
        });

        return monsters;
    }
};